import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../components/Modal/Modal";
import Button, { ButtonType } from "../../components/Button/Button";
import { Container, StyledInput, Wrapper } from "../../components/styled/styled-components";
import "../../styles/components/ModalSwitcher.scss";
import { useNavigate } from "react-router-dom";

interface Props {
  modalToShow: number;
  setModalToShow: React.Dispatch<React.SetStateAction<number>>;
  clearCart: () => void;
  saveOrder: () => void;
  modalMessage: string;
  isLoading: boolean;
  saveOrderInput?: string;
  setSaveOrderInput: React.Dispatch<React.SetStateAction<string>>;
}

const ModalSwitcher = ({
  modalToShow,
  setModalToShow,
  clearCart,
  saveOrder,
  modalMessage,
  isLoading,
  setSaveOrderInput,
  saveOrderInput = "",
}: Props) => {
  const navigate = useNavigate();

  switch (modalToShow) {
    case 1:
      return (
        <Modal>
          <Container className="cart-modal-template">
            <h5>Would you like to empty your cart?</h5>
            {isLoading ? (
              <Wrapper margin="1em 0">
                <LoadingSpinner />
              </Wrapper>
            ) : (
              <Container row jcsa margin="2em 0 0 0">
                <Button
                  type={ButtonType.primary}
                  onClick={() => clearCart()}
                  className="modal-switcher__button"
                >
                  Yes
                </Button>
                <Button
                  type={ButtonType.secondary}
                  onClick={() => setModalToShow(-1)}
                  className="modal-switcher__button"
                >
                  No
                </Button>
              </Container>
            )}
          </Container>
        </Modal>
      );
    case 4:
      return (
        <Modal>
          <Container className="cart-modal-template">
            <p>{modalMessage}</p>
            <Container row jcsa>
              <Button
                type={ButtonType.primary}
                onClick={() => window.location.reload()}
                className="modal-switcher__button"
              >
                Back to cart
              </Button>
            </Container>
          </Container>
        </Modal>
      );
    case 2:
      return (
        <Modal>
          <Container className="cart-modal-template">
            <p>Enter an order note</p>
            <form>
              <Wrapper margin="1em 0">
                <StyledInput onChange={(event) => setSaveOrderInput(event.target.value)} />
              </Wrapper>
              {isLoading ? (
                <Wrapper margin="1em 0">
                  <LoadingSpinner />
                </Wrapper>
              ) : (
                <Container row jcsa>
                  <Button
                    type={ButtonType.primary}
                    disabled={!saveOrderInput}
                    onClick={(event) => {
                      if (!saveOrderInput) return;
                      saveOrder();
                      event.preventDefault();
                    }}
                    className="modal-switcher__button"
                  >
                    Save
                  </Button>
                  <Button
                    type={ButtonType.secondary}
                    onClick={() => setModalToShow(-1)}
                    className="modal-switcher__button"
                  >
                    Cancel
                  </Button>
                </Container>
              )}
            </form>
          </Container>
        </Modal>
      );
    case 3:
      return (
        <Modal>
          <Container className="cart-modal-template">
            <p>{modalMessage}</p>
            <Container row jcsa>
              <Button
                type={ButtonType.primary}
                onClick={() => window.location.reload()}
                className="modal-switcher__button"
              >
                Back to cart
              </Button>
              <Button
                type={ButtonType.secondary}
                onClick={() => navigate("/saved-orders")}
                className="modal-switcher__button"
              >
                Go to Saved Orders
              </Button>
            </Container>
          </Container>
        </Modal>
      );
    case 5:
      return (
        <Modal>
          <Container className="cart-modal-template">
            <p>
              <b>{modalMessage}</b>
            </p>
            <Container row jcsa>
              <Button
                type={ButtonType.primary}
                onClick={() => window.location.reload()}
                className="modal-switcher__button"
              >
                Back to cart
              </Button>
              <Button
                type={ButtonType.secondary}
                onClick={() => navigate("/saved-orders")}
                className="modal-switcher__button"
              >
                Go to Saved Orders
              </Button>
            </Container>
          </Container>
        </Modal>
      );

    default:
      return <></>;
  }
};

export default ModalSwitcher;
